import React from "react";
import { PageHeader } from "../components/PageHeader";
import { criteria, partners, prizes, program, rules } from "../data/program";
import { schedule } from "../data/schedule";
import { currentProgramDay, formatDay, PROGRAM_DAYS } from "../utils/dates";
export function Program() {
  const today = currentProgramDay();
  const [first, second, third, ...rest] = prizes;
  return <main className="mx-auto max-w-6xl px-5 py-10 md:px-8 md:py-12" data-id="element-987" data-mp="3qrvhoqwdrqda">
      <PageHeader title="Program & schedule" description={program.summary} data-id="element-988" data-mp="3qq2btdtlda6c" />

      <section aria-labelledby="partners-heading" className="mt-10" data-id="element-989" data-mp="3ms4mmaztmo2y">
        <h2 id="partners-heading" className="pb-3 text-lg font-semibold" data-id="element-990" data-mp="4ctyvaalaqnt">
          In partnership with
        </h2>
        <div className="grid gap-6 border-y border-line py-6 md:grid-cols-3 md:gap-0 md:divide-x md:divide-line" data-id="element-991" data-mp="3vqg8jzpqsxp2">
          {partners.map(p => <div key={p.name} className="md:px-6 md:first:pl-0 md:last:pr-0" data-id="element-992" data-mp="332kcmx7zz9tc">
              <p className="text-[17px] font-bold" data-id="element-993" data-mp="330hoyjubhsrs">{p.name}</p>
              <p className="text-sm font-medium text-saffron-ink" data-id="element-994" data-mp="slqjljz0m5qo">{p.role}</p>
              <p className="mt-2 text-sm text-muted" data-id="element-995" data-mp="xlbjbwm0ei4g">{p.description}</p>
            </div>)}
        </div>
      </section>

      <section aria-labelledby="prizes-heading" className="mt-12" data-id="element-996" data-mp="12dwg9707pbc7">
        <h2 id="prizes-heading" className="pb-3 text-lg font-semibold" data-id="element-997" data-mp="17c67x7mq9tt2">
          Prizes
        </h2>
        <div className="grid gap-4 md:grid-cols-[1.4fr_1fr_1fr]" data-id="element-998" data-mp="9opfs2h76bob">
          <div className="bg-waves rounded-2xl px-6 py-7 text-white" data-id="element-999" data-mp="9q8tpmfdsamx">
            <p className="text-sm font-semibold text-bryellow" data-id="element-1000" data-mp="en93a7bfvvis">{first.label}</p>
            <p className="mt-1 text-5xl font-bold tabular-nums" data-id="element-1001" data-mp="jlal6ox4poso">{first.amount}</p>
          </div>
          {[second, third].map(p => <div key={p.place} className="rounded-2xl border border-line bg-surface px-6 py-7" data-id="element-1002" data-mp="nlcd46d2b3ur">
              <p className="text-sm font-semibold text-muted" data-id="element-1003" data-mp="1v3brnxvsh68n">{p.label}</p>
              <p className="mt-1 text-4xl font-bold tabular-nums" data-id="element-1004" data-mp="1z19ewv601i9e">{p.amount}</p>
            </div>)}
        </div>
        <p className="mt-3 text-sm text-muted" data-id="element-1005" data-mp="6urbywfllb">
          {rest.map(p => p.label).join(" and ")}: prize to be announced.
        </p>
      </section>

      <section aria-labelledby="schedule-heading" className="mt-12" data-id="element-1006" data-mp="8xpmt0ayn06p">
        <h2 id="schedule-heading" className="pb-3 text-lg font-semibold" data-id="element-1007" data-mp="3zxj790ydpmo">
          Schedule
        </h2>
        <p className="-mt-1 pb-4 text-sm text-muted" data-id="element-1008" data-mp="3cf7qqwnm3n1u">All times Pacific. Daily videos are due at 21:00.</p>
        <ol className="divide-y divide-line rounded-xl border border-line bg-surface" data-id="element-1009" data-mp="38efio6qh7o75">
          {schedule.map(d => {
          const isToday = d.day === today;
          const isDemo = d.day === PROGRAM_DAYS + 1;
          return <li key={d.day} className={`grid gap-4 px-5 py-5 md:grid-cols-[180px_1fr] ${isToday ? "bg-bryellow/10" : ""}`} data-id="element-1010" data-mp="3hd9bdm0oruff">
                <div data-id="element-1011" data-mp="2opwotbuizmm4">
                  <p className="text-sm font-semibold" data-id="element-1012" data-mp="2oqg9h0bk8p3u">
                    {isDemo ? "Demo Day" : `Day ${d.day}`}
                    {isToday && <span className="ml-2 rounded bg-bryellow px-1.5 py-0.5 text-[11px] font-bold text-navy" data-id="element-1013" data-mp="1472nq2jdr86e">Today</span>}
                  </p>
                  <p className="text-sm text-muted" data-id="element-1014" data-mp="190fdwh3pjn19">{formatDay(d.day, "EEE, MMM d")}</p>
                </div>
                <div data-id="element-1015" data-mp="106af9bic17b6">
                  <p className="text-[17px] font-semibold" data-id="element-1016" data-mp="105hfiuhsji2j">{d.theme}</p>
                  <ul className="mt-2 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-1017" data-mp="1nvv8cn879ky6">
                    {d.sessions.map(s => <li key={s.time + s.title} className="flex gap-3 text-sm" data-id="element-1018" data-mp="1rxqa1su1m0ch">
                        <span className="w-11 shrink-0 tabular-nums text-muted" data-id="element-1019" data-mp="1dxxla322tu75">{s.time}</span>
                        <span data-id="element-1020" data-mp="1iwibrarj0zie">
                          {s.title}
                          {s.detail && <span className="text-muted" data-id="element-1021" data-mp="1iylb4lekk4zs"> · {s.detail}</span>}
                        </span>
                      </li>)}
                  </ul>
                  {d.videoPrompt && <p className="mt-3 text-sm text-saffron-ink" data-id="element-1022" data-mp="mr8k5qx3wyym">Video prompt: {d.videoPrompt}</p>}
                </div>
              </li>;
        })}
        </ol>
      </section>

      <div className="mt-12 grid gap-10 lg:grid-cols-2" data-id="element-1023" data-mp="dyoo8y8798hh">
        <section aria-labelledby="rules-heading" data-id="element-1024" data-mp="dz6mu1ic3ysk">
          <h2 id="rules-heading" className="pb-3 text-lg font-semibold" data-id="element-1025" data-mp="90mw7nsspytv">
            Rules
          </h2>
          <ul className="space-y-3" data-id="element-1026" data-mp="15qe3knm6rgh3">
            {rules.map(r => <li key={r} className="flex gap-3 text-[15px]" data-id="element-1027" data-mp="11oshqcrobrur">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-saffron" aria-hidden="true" data-id="element-1028" data-mp="11paldugo18cp" />
                {r}
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="criteria-heading" data-id="element-1029" data-mp="rpth9hh2b2iu">
          <h2 id="criteria-heading" className="pb-3 text-lg font-semibold" data-id="element-1030" data-mp="3hfdknre2j1tf">
            Judging criteria
          </h2>
          <table className="w-full text-left text-sm" data-id="element-1031" data-mp="3cfiwhvlogqc2">
            <tbody className="divide-y divide-line border-y border-line" data-id="element-1032" data-mp="3ciwyv3ucczji">
              {criteria.map(c => <tr key={c.id} data-id="element-1033" data-mp="37bgr0qx9uv9g">
                  <td className="py-3 pr-4" data-id="element-1034" data-mp="37cruepmt2101">
                    <p className="font-semibold" data-id="element-1035" data-mp="379dr9f6bhnrj">{c.label}</p>
                    <p className="text-muted" data-id="element-1036" data-mp="3ca1j232de8mt">{c.description}</p>
                  </td>
                  <td className="py-3 text-right text-base font-bold tabular-nums" data-id="element-1037" data-mp="3h2l4tnb7oa2p">{c.weight}%</td>
                </tr>)}
            </tbody>
          </table>
        </section>
      </div>
    </main>;
}